var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#5AA2DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2001 5.60001C12.8818 5.60001 12.5766 5.72643 12.3516 5.95148C12.1265 6.17652 12.0001 6.48175 12.0001 6.80001C12.0001 7.11827 12.1265 7.42349 12.3516 7.64853C12.5766 7.87358 12.8818 8.00001 13.2001 8.00001C13.5184 8.00001 13.8236 7.87358 14.0486 7.64853C14.2737 7.42349 14.4001 7.11827 14.4001 6.80001C14.4001 6.48175 14.2737 6.17652 14.0486 5.95148C13.8236 5.72643 13.5184 5.60001 13.2001 5.60001ZM12.9121 9.41601C11.9601 9.49601 9.3601 11.568 9.3601 11.568C9.2001 11.688 9.2481 11.68 9.3761 11.904C9.5041 12.12 9.4881 12.136 9.6401 12.032C9.8001 11.928 10.0641 11.76 10.5041 11.488C12.2001 10.4 10.7761 12.912 10.0481 17.144C9.7601 19.24 11.6481 18.16 12.1361 17.84C12.6161 17.528 13.9041 16.64 14.0321 16.552C14.2081 16.432 14.0801 16.336 13.9441 16.136C13.8481 16 13.7521 16.096 13.7521 16.096C13.2321 16.44 12.2801 17.16 12.1521 16.704C12.0001 16.248 12.9761 13.12 13.5121 10.968C13.6001 10.456 13.8401 9.33601 12.9121 9.41601Z",
    fill: "#5AA2DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.2660ac06446f77a65e3e5c9c63d8c7f5.svg";
export { ForwardRef as ReactComponent };